// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Webflow channel (WebflowSitePanel.js): one row per site, no boxes. Every
   part sits the same 16px apart; the doubled class outranks the integration
   page's ".integration-tab-content p" margins and font size. */
.wf-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 640px;
  color: #2b2140;
}
.wf-panel.wf-panel > *,
.wf-panel.wf-panel p {
  margin: 0;
}
.wf-panel__head {
  display: flex;
  align-items: center;
  gap: 12px;
}
.wf-panel__conn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #4b4360;
}
.wf-panel__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1f9d55;
}
.wf-panel__spacer {
  flex: 1 1;
}
.wf-panel__link {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-size: 13px;
  color: #6b5f85;
  text-decoration: underline;
  cursor: pointer;
}
.wf-panel__link:hover:not(:disabled) {
  color: #2b2140;
}
.wf-panel__change {
  align-self: flex-start;
}
.wf-panel .wf-panel__intro {
  font-size: 14px;
  line-height: 1.5;
  color: #6b5f85;
}
.wf-panel .wf-panel__error {
  font-size: 14px;
  color: #b42318;
}
.wf-panel__loading {
  padding: 12px 0;
  color: #5616ea;
}
.wf-panel__connect {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 0;
  border-radius: 8px;
  background: #5616ea;
  color: #fff;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.wf-panel__connect:hover:not(:disabled) {
  background: #4a14d6;
}

.wf-site {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 8px 12px 16px;
  border: 1px solid #e6e1f2;
  border-radius: 10px;
}
.wf-site__main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.wf-site__name {
  font-weight: 600;
  font-size: 15px;
}
.wf-site__select {
  max-width: 320px;
  padding: 6px 8px;
  border: 1px solid #d6cfe8;
  border-radius: 6px;
  font: inherit;
  font-size: 15px;
  background: #fff;
}
.wf-site__url {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #5616ea;
  text-decoration: none;
  overflow-wrap: anywhere;
}
.wf-site__url:hover {
  text-decoration: underline;
}
.wf-site__url svg {
  font-size: 11px;
}
.wf-site__busy {
  color: #5616ea;
}

.wf-pill {
  flex: 0 0 auto;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.wf-pill--live {
  background: #e7f7ee;
  color: #17723f;
}
.wf-pill--pending {
  background: #fdf3dc;
  color: #8a5a00;
}
.wf-pill--off {
  background: #f1eef6;
  color: #6b5f85;
}

.wf-panel__help {
  font-size: 13px;
  color: #6b5f85;
}
.wf-panel__help summary {
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
}
.wf-panel.wf-panel .wf-panel__help p {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.5;
}

@media (max-width: 480px) {
  .wf-site {
    flex-wrap: wrap;
  }
  .wf-site__main {
    flex-basis: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WebflowSitePanel.css"],"names":[],"mappings":"AAAA;;+DAE+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,SAAO;AACT;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Webflow channel (WebflowSitePanel.js): one row per site, no boxes. Every\r\n   part sits the same 16px apart; the doubled class outranks the integration\r\n   page's \".integration-tab-content p\" margins and font size. */\r\n.wf-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  max-width: 640px;\r\n  color: #2b2140;\r\n}\r\n.wf-panel.wf-panel > *,\r\n.wf-panel.wf-panel p {\r\n  margin: 0;\r\n}\r\n.wf-panel__head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n.wf-panel__conn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n  color: #4b4360;\r\n}\r\n.wf-panel__dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #1f9d55;\r\n}\r\n.wf-panel__spacer {\r\n  flex: 1;\r\n}\r\n.wf-panel__link {\r\n  padding: 0;\r\n  border: 0;\r\n  background: none;\r\n  font: inherit;\r\n  font-size: 13px;\r\n  color: #6b5f85;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n.wf-panel__link:hover:not(:disabled) {\r\n  color: #2b2140;\r\n}\r\n.wf-panel__change {\r\n  align-self: flex-start;\r\n}\r\n.wf-panel .wf-panel__intro {\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: #6b5f85;\r\n}\r\n.wf-panel .wf-panel__error {\r\n  font-size: 14px;\r\n  color: #b42318;\r\n}\r\n.wf-panel__loading {\r\n  padding: 12px 0;\r\n  color: #5616ea;\r\n}\r\n.wf-panel__connect {\r\n  align-self: flex-start;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 16px;\r\n  border: 0;\r\n  border-radius: 8px;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font: inherit;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n.wf-panel__connect:hover:not(:disabled) {\r\n  background: #4a14d6;\r\n}\r\n\r\n.wf-site {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 8px 12px 16px;\r\n  border: 1px solid #e6e1f2;\r\n  border-radius: 10px;\r\n}\r\n.wf-site__main {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n.wf-site__name {\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n}\r\n.wf-site__select {\r\n  max-width: 320px;\r\n  padding: 6px 8px;\r\n  border: 1px solid #d6cfe8;\r\n  border-radius: 6px;\r\n  font: inherit;\r\n  font-size: 15px;\r\n  background: #fff;\r\n}\r\n.wf-site__url {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n  color: #5616ea;\r\n  text-decoration: none;\r\n  overflow-wrap: anywhere;\r\n}\r\n.wf-site__url:hover {\r\n  text-decoration: underline;\r\n}\r\n.wf-site__url svg {\r\n  font-size: 11px;\r\n}\r\n.wf-site__busy {\r\n  color: #5616ea;\r\n}\r\n\r\n.wf-pill {\r\n  flex: 0 0 auto;\r\n  padding: 3px 10px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n.wf-pill--live {\r\n  background: #e7f7ee;\r\n  color: #17723f;\r\n}\r\n.wf-pill--pending {\r\n  background: #fdf3dc;\r\n  color: #8a5a00;\r\n}\r\n.wf-pill--off {\r\n  background: #f1eef6;\r\n  color: #6b5f85;\r\n}\r\n\r\n.wf-panel__help {\r\n  font-size: 13px;\r\n  color: #6b5f85;\r\n}\r\n.wf-panel__help summary {\r\n  cursor: pointer;\r\n  width: fit-content;\r\n}\r\n.wf-panel.wf-panel .wf-panel__help p {\r\n  margin-top: 8px;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .wf-site {\r\n    flex-wrap: wrap;\r\n  }\r\n  .wf-site__main {\r\n    flex-basis: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
